
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PorcelanicosSection from '../../components/feature/PorcelanicosSection';

export default function PorcelanicosPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-white min-h-screen flex items-center">
        <div className="w-full mx-auto text-center" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
          <h1 
            className="font-light text-gray-900" 
            style={{ 
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(2.5rem, 5vw, 7rem)',
              marginBottom: 'clamp(1rem, 2vh, 3rem)'
            }}
          >
            PORCELANICOS
          </h1>
          <p 
            className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
            style={{ 
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(1rem, 1.2vw, 2rem)',
              padding: '0 clamp(1rem, 2vw, 3rem)'
            }}
          >
            Entre las propiedades más destacadas de este material podemos encontrar su gran resistencia a multitud de circunstancias debido a su gran dureza superficial, ofreciendo grandes resultados contra rayados, abrasión y altas cargas de peso.
          </p>
        </div>
      </div>

      <PorcelanicosSection />

      <Footer />
    </div>
  );
}
